module.exports = __webpack_public_path__ + "static/media/account-white.9fca30e0.svg";